export const ACCOUNT_NAV_RECS_TARGET_ID = 'account-nav-recommendations-target';
